import React from 'react'
import ProductsHero from '../../components/ProductComponets/ProductsHero'
import FeaturedProducts from '../../components/ProductComponets/FeaturedProducts'
// import ProductCta from '../../components/ProductComponets/ProductCta'
// import ProductCategories from '../../components/ProductComponets/ProductCategories'

const ProductPage = () => {
  return (
    <div className='ProductPage my-10 py-10 sm:p-10'>
      <ProductsHero />
      <FeaturedProducts />
      {/* <ProductCategories /> */}
      {/* <ProductCta /> */}
    </div>
  )
}

export default ProductPage